// Split out of PerFigureAnnotationTabs.tsx (react-refresh/only-export-components)
// — the per-figure state shape + its factory, not a component. Behavior unchanged.

import type { Annotation } from '@/components/canvas';
import type { PhaseConfig } from '@/components/phase';
import type { Phase } from '@/types/api';
import type { SpeedThreshold } from '@/types/trajectory';

// ---------------------------------------------------------------------------
// Per-figure annotation state
// ---------------------------------------------------------------------------

export interface FigureAnnotationState {
  annotations: Annotation[];
  phases: Phase[];
  phaseConfigs: PhaseConfig[];
  phaseSpeedIntents: Record<string, 'match' | 'reward_faster' | 'reward_slower' | 'off'>;
  trimStartFrame: number;
  trimEndFrame: number;
  coach_notes: string;
  coaching_cues: string[];
  globalBodyMatchEnabled: boolean;
  globalBodyMatchWeight: number;
  rotationSensitive: boolean;
  economyOfMotionWeight: number;
  speedThreshold: SpeedThreshold | undefined;
  /** P1-1/P1-2 speed scoring switch per figure (positional mode). Default 'off'. */
  speedMode: 'off' | 'on';
  /**
   * P1-4 speed weight per figure (positional mode). Undefined = use default (0.15).
   * No preview/acknowledge gate in positional mode (no templateId available there).
   */
  speedWeight: number | undefined;
}

export function emptyFigureState(trimStart: number, trimEnd: number): FigureAnnotationState {
  return {
    annotations: [],
    phases: [],
    phaseConfigs: [],
    phaseSpeedIntents: {},
    trimStartFrame: trimStart,
    trimEndFrame: trimEnd,
    coach_notes: '',
    coaching_cues: [],
    globalBodyMatchEnabled: true,
    globalBodyMatchWeight: 0.5,
    rotationSensitive: false,
    economyOfMotionWeight: 0.1,
    speedThreshold: undefined,
    speedMode: 'off',
    speedWeight: undefined,
  };
}
